export const cahced_maker_metas = [
  {
    id: 523,
    name: 'printable_info',
    value: {
      printable_info: {
        cutline: {
          type: 'rectangle',
          border: { color: { key: 0, cyan: 0, yellow: 0, magenta: 1 }, width: 1, opacity: 1 },
          geometry: {
            lt_x_to_page_width_ratio: 0.026,
            lt_y_to_page_height_ratio: 0.042,
            width_to_page_width_ratio: 0.947,
            height_to_page_height_ratio: 0.917,
          },
        },
        setting: {
          main: { width: 90, height: 55 },
          type: '반칼',
          shape: 'rectangle',
          need_mask: true,
          px_per_1cm: 75,
        },
        real_printing_area: { width_mm: 95, height_mm: 60, padding_mm: 0.5, safe_padding_mm: 4.5 },
        material_for_maker_material: {
          mask: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/ad67ee858388012b892db19c8b0ebea0631d374b1.png',
            width: 1720,
            height: 1087,
          },
          safe_area: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/c127652e13510b06bc13bd323454d4c33f0e77ad1.png',
            width: 1558,
            height: 924,
          },
          background: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/b5a3c08ce6a7a1550e5d0235d5bcfe4166275f561.png',
            width: 1720,
            height: 1087,
          },
          px_per_1cm: 75,
          dotted_area: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/1284b120b8c7b20170c93f23614ba2960d58ac0f1.png',
            width: 1720,
            height: 1087,
          },
          printing_area: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/add623b506c50c9396dcd497878dbe6352d361d01.png',
            width: 1702,
            height: 1069,
          },
          print_mask_url:
            '//s3.marpple.co/files/u_193535/2024/10/original/ad67ee858388012b892db19c8b0ebea0631d374b1.png',
          half_cutting_area: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/c8d35d29e8946e4e29ce0f8ee33c2f475686761d1.png',
            width: 1720,
            height: 1087,
          },
        },
      },
    },
  },
  {
    id: 524,
    name: 'printable_info',
    value: {
      printable_info: {
        cutline: {
          type: 'rectangle',
          border: { color: { key: 0, cyan: 0, yellow: 0, magenta: 1 }, width: 1, opacity: 1 },
          geometry: {
            lt_x_to_page_width_ratio: 0.026,
            lt_y_to_page_height_ratio: 0.033,
            width_to_page_width_ratio: 0.947,
            height_to_page_height_ratio: 0.933,
          },
        },
        setting: {
          main: { width: 90, height: 70 },
          type: '반칼',
          shape: 'rectangle',
          need_mask: true,
          px_per_1cm: 75,
        },
        real_printing_area: { width_mm: 95, height_mm: 75, padding_mm: 0.5, safe_padding_mm: 4.5 },
        material_for_maker_material: {
          mask: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/9e83d82d02fdb3d787db8d34cf4868071e9797e21.png',
            width: 1720,
            height: 1358,
          },
          safe_area: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/32a8de315da1f274726516e5f239f281111624c31.png',
            width: 1558,
            height: 1195,
          },
          background: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/d30d77f3aeed06bb63b16776021fa05a4f995d501.png',
            width: 1720,
            height: 1358,
          },
          px_per_1cm: 75,
          dotted_area: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/d2ec9f2080eed4951eee122bf3f25fcfc4cf2d301.png',
            width: 1720,
            height: 1358,
          },
          printing_area: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/5a149ea5fbc5589ea37e076391016d5e05e4b86c1.png',
            width: 1702,
            height: 1340,
          },
          print_mask_url:
            '//s3.marpple.co/files/u_193535/2024/10/original/9e83d82d02fdb3d787db8d34cf4868071e9797e21.png',
          half_cutting_area: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/696c6f6611f485772856417a58cd28d2a0b1d9a11.png',
            width: 1720,
            height: 1358,
          },
        },
      },
    },
  },
  {
    id: 525,
    name: 'printable_info',
    value: {
      printable_info: {
        cutline: {
          type: 'rectangle',
          border: { color: { key: 0, cyan: 0, yellow: 0, magenta: 1 }, width: 1, opacity: 1 },
          geometry: {
            lt_x_to_page_width_ratio: 0.026,
            lt_y_to_page_height_ratio: 0.029,
            width_to_page_width_ratio: 0.947,
            height_to_page_height_ratio: 0.941,
          },
        },
        setting: {
          main: { width: 90, height: 80 },
          type: '반칼',
          shape: 'rectangle',
          need_mask: true,
          px_per_1cm: 75,
        },
        real_printing_area: { width_mm: 95, height_mm: 85, padding_mm: 0.5, safe_padding_mm: 4.5 },
        material_for_maker_material: {
          mask: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/c4b140d188c10a5caae2e9131f1e3017670cca851.png',
            width: 1720,
            height: 1539,
          },
          safe_area: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/8854d7d1a08c7bdaf006b6e54c6a2251655924da1.png',
            width: 1558,
            height: 1376,
          },
          background: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/fb3f98730fb997fdb8aaa87a34d7243963b39ad81.png',
            width: 1720,
            height: 1539,
          },
          px_per_1cm: 75,
          dotted_area: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/007093279f6cc42a622bf244c5e6c8cde60e74ee1.png',
            width: 1720,
            height: 1539,
          },
          printing_area: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/7bc398f56dde3c0878ffa558acc8f1708879d35b1.png',
            width: 1702,
            height: 1521,
          },
          print_mask_url:
            '//s3.marpple.co/files/u_193535/2024/10/original/c4b140d188c10a5caae2e9131f1e3017670cca851.png',
          half_cutting_area: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/24fb184a24d74f3f043e649063b31043098f20401.png',
            width: 1720,
            height: 1539,
          },
        },
      },
    },
  },
  {
    id: 526,
    name: 'printable_info',
    value: {
      printable_info: {
        cutline: {
          type: 'rectangle',
          border: { color: { key: 0, cyan: 0, yellow: 0, magenta: 1 }, width: 1, opacity: 1 },
          geometry: {
            lt_x_to_page_width_ratio: 0.026,
            lt_y_to_page_height_ratio: 0.026,
            width_to_page_width_ratio: 0.947,
            height_to_page_height_ratio: 0.947,
          },
        },
        setting: {
          main: { width: 90, height: 90 },
          type: '반칼',
          shape: 'rectangle',
          need_mask: true,
          px_per_1cm: 75,
        },
        real_printing_area: { width_mm: 95, height_mm: 95, padding_mm: 0.5, safe_padding_mm: 4.5 },
        material_for_maker_material: {
          mask: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/9e043380638984b2378065aa3d68986db39372321.png',
            width: 1720,
            height: 1720,
          },
          safe_area: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/60e39f8ac3be5118acbcc4dbba4fdca83b9621b51.png',
            width: 1558,
            height: 1558,
          },
          background: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/efdaea33c739539a47b9d0e23be39331156466351.png',
            width: 1720,
            height: 1720,
          },
          px_per_1cm: 75,
          dotted_area: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/c2f60195aa9249a2c29eea3f77ebe127a71fc2811.png',
            width: 1720,
            height: 1720,
          },
          printing_area: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/52ce3f13b0845f07ea0bda67d539d4c249f4ced71.png',
            width: 1702,
            height: 1702,
          },
          print_mask_url:
            '//s3.marpple.co/files/u_193535/2024/10/original/9e043380638984b2378065aa3d68986db39372321.png',
          half_cutting_area: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/9a0ff3f2cf78666f5cf3bc7aa3052670919995d91.png',
            width: 1720,
            height: 1720,
          },
        },
      },
    },
  },
  {
    id: 527,
    name: 'printable_info',
    value: {
      printable_info: {
        cutline: {
          type: 'rectangle',
          border: { color: { key: 0, cyan: 0, yellow: 0, magenta: 1 }, width: 1, opacity: 1 },
          geometry: {
            lt_x_to_page_width_ratio: 0.026,
            lt_y_to_page_height_ratio: 0.024,
            width_to_page_width_ratio: 0.947,
            height_to_page_height_ratio: 0.952,
          },
        },
        setting: {
          main: { width: 90, height: 100 },
          type: '반칼',
          shape: 'rectangle',
          need_mask: true,
          px_per_1cm: 70,
        },
        real_printing_area: { width_mm: 95, height_mm: 105, padding_mm: 0.5, safe_padding_mm: 4.5 },
        material_for_maker_material: {
          mask: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/f9857ff73242ffda78c7cca0c7a71198203bef201.png',
            width: 1720,
            height: 1902,
          },
          safe_area: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/e421dbfb4d92b28b14e22fc4a0031ceda787ec351.png',
            width: 1558,
            height: 1739,
          },
          background: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/e50cb2254f12badb76205894bef2acd1066c75ab1.png',
            width: 1720,
            height: 1902,
          },
          px_per_1cm: 70,
          dotted_area: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/d01f7eb8fd488ded4a659598474c2964d9c7a2b31.png',
            width: 1720,
            height: 1902,
          },
          printing_area: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/de8df797455580d8a10c8cbbba588c25ea24dbf91.png',
            width: 1702,
            height: 1883,
          },
          print_mask_url:
            '//s3.marpple.co/files/u_193535/2024/10/original/f9857ff73242ffda78c7cca0c7a71198203bef201.png',
          half_cutting_area: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/7c78891a77fa2493523d11721d89d9f5e8036ef51.png',
            width: 1720,
            height: 1902,
          },
        },
      },
    },
  },
  {
    id: 528,
    name: 'printable_info',
    value: {
      printable_info: {
        cutline: {
          type: 'rectangle',
          border: { color: { key: 0, cyan: 0, yellow: 0, magenta: 1 }, width: 1, opacity: 1 },
          geometry: {
            lt_x_to_page_width_ratio: 0.026,
            lt_y_to_page_height_ratio: 0.022,
            width_to_page_width_ratio: 0.947,
            height_to_page_height_ratio: 0.957,
          },
        },
        setting: {
          main: { width: 90, height: 110 },
          type: '반칼',
          shape: 'rectangle',
          need_mask: true,
          px_per_1cm: 63.64,
        },
        real_printing_area: { width_mm: 95, height_mm: 115, padding_mm: 0.5, safe_padding_mm: 4.5 },
        material_for_maker_material: {
          mask: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/10f4ad5875638ffa53314a052d78b634ecedbc981.png',
            width: 1720,
            height: 2083,
          },
          safe_area: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/2d5c5516b21129fa8f4d3885d38d3a9d3b4954371.png',
            width: 1558,
            height: 1920,
          },
          background: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/db86fd4c55ed468245348e5a4cfe381d2159853e1.png',
            width: 1720,
            height: 2083,
          },
          px_per_1cm: 63.64,
          dotted_area: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/d5bb96c9e8076b79061557187dba8641780625e61.png',
            width: 1720,
            height: 2083,
          },
          printing_area: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/daf161396e472611c99e5333d2d486bf223231e01.png',
            width: 1702,
            height: 2064,
          },
          print_mask_url:
            '//s3.marpple.co/files/u_193535/2024/10/original/10f4ad5875638ffa53314a052d78b634ecedbc981.png',
          half_cutting_area: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/20594c51ce590e0cd7d7d645035fb900b794eb1e1.png',
            width: 1720,
            height: 2083,
          },
        },
      },
    },
  },
  {
    id: 529,
    name: 'printable_info',
    value: {
      printable_info: {
        cutline: {
          type: 'rectangle',
          border: { color: { key: 0, cyan: 0, yellow: 0, magenta: 1 }, width: 1, opacity: 1 },
          geometry: {
            lt_x_to_page_width_ratio: 0.026,
            lt_y_to_page_height_ratio: 0.02,
            width_to_page_width_ratio: 0.947,
            height_to_page_height_ratio: 0.96,
          },
        },
        setting: {
          main: { width: 90, height: 120 },
          type: '반칼',
          shape: 'rectangle',
          need_mask: true,
          px_per_1cm: 58.33,
        },
        real_printing_area: { width_mm: 95, height_mm: 125, padding_mm: 0.5, safe_padding_mm: 4.5 },
        material_for_maker_material: {
          mask: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/8c24b6cdab321fa30a4931734b16ebfd54d3c4ec1.png',
            width: 1720,
            height: 2264,
          },
          safe_area: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/f4352337125170a45df6beb905097587769db04e1.png',
            width: 1558,
            height: 2101,
          },
          background: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/d43168605552a910c62263b109f7b4043f07b08b1.png',
            width: 1720,
            height: 2264,
          },
          px_per_1cm: 58.33,
          dotted_area: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/4515f1d2d074148c7cf8642f666e053443b711301.png',
            width: 1720,
            height: 2264,
          },
          printing_area: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/33cbd59d1e8b2d170a9edad0ef81bf72fdcda9311.png',
            width: 1702,
            height: 2246,
          },
          print_mask_url:
            '//s3.marpple.co/files/u_193535/2024/10/original/8c24b6cdab321fa30a4931734b16ebfd54d3c4ec1.png',
          half_cutting_area: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/f078672ab01826050ff2ba47867b890c5a3011071.png',
            width: 1720,
            height: 2264,
          },
        },
      },
    },
  },
  {
    id: 530,
    name: 'printable_info',
    value: {
      printable_info: {
        cutline: {
          type: 'rectangle',
          border: { color: { key: 0, cyan: 0, yellow: 0, magenta: 1 }, width: 1, opacity: 1 },
          geometry: {
            lt_x_to_page_width_ratio: 0.026,
            lt_y_to_page_height_ratio: 0.019,
            width_to_page_width_ratio: 0.947,
            height_to_page_height_ratio: 0.963,
          },
        },
        setting: {
          main: { width: 90, height: 130 },
          type: '반칼',
          shape: 'rectangle',
          need_mask: true,
          px_per_1cm: 53.85,
        },
        real_printing_area: { width_mm: 95, height_mm: 135, padding_mm: 0.5, safe_padding_mm: 4.5 },
        material_for_maker_material: {
          mask: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/4029f6fa62d0a3a1ff863055aeac276a500924371.png',
            width: 1720,
            height: 2445,
          },
          safe_area: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/e3b91d3ef1e628ca14b4efd615ba12cddb7ff28e1.png',
            width: 1558,
            height: 2282,
          },
          background: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/100e98c54ee4f85220616e1ab2a0f6efa05bdc431.png',
            width: 1720,
            height: 2445,
          },
          px_per_1cm: 53.85,
          dotted_area: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/151df598244b3abf040e57f8a136f612c10f077d1.png',
            width: 1720,
            height: 2445,
          },
          printing_area: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/f48ae909e5466f3d1743e188760a2d0377a504801.png',
            width: 1702,
            height: 2427,
          },
          print_mask_url:
            '//s3.marpple.co/files/u_193535/2024/10/original/4029f6fa62d0a3a1ff863055aeac276a500924371.png',
          half_cutting_area: {
            url: '//s3.marpple.co/files/u_193535/2024/10/original/383c0f43536cff0e6c66e2e080da3aadf6238f2f1.png',
            width: 1720,
            height: 2445,
          },
        },
      },
    },
  },
];
